import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mui/material';

const LogoutButton = ({ fullWidth }) => {
  const { logout, isAuthenticated } = useAuth0();

  if (isAuthenticated) {
    return (
      <Button 
        color="inherit" 
        onClick={() => logout({ returnTo: window.location.origin })}
        fullWidth={fullWidth}
      >
        Log Out
      </Button>
    );
  }
  return null;
};

export default LogoutButton;